import React from "react"
import { FormattedMessage } from "react-intl"
import "./index.scss"

interface HeaderProps {
	title: string
	color: string
	icon: React.ReactChild
}

const Header: React.FC<HeaderProps> = ({ title, color, icon }) => (
	<div style={{ backgroundColor: color }} className="summarycard-header">
		<div className="header-icon">{icon}</div>
		<div className="header-title">
			<FormattedMessage id={title} />
		</div>
	</div>
)

export default Header
